export default __webpack_public_path__ + "static/media/win-precent-icon.63527d9c.svg";